var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"data-test":"cloneEntryRules"}},[_c('br'),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.$t(
      "events:EventCardLarge.CloneModal.entryRulesCloningSettings.subheading",
      "Choose setting for cloning of competitions´ entry rules"
    )))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-radio-group',{model:{value:(_setup.cloneValue),callback:function ($$v) {_setup.cloneValue=$$v},expression:"cloneValue"}},[_c('v-radio',{attrs:{"label":_vm.$t(
          'events:EventCardLarge.CloneModal.entryRulesCloningSettings.useFromSourceEvent.label',
          'Keep competitions entry rule conditions from source event'
        ),"value":true}}),_vm._v(" "),_c('v-radio',{attrs:{"label":_vm.$t(
          'events:EventCardLarge.CloneModal.entryRulesCloningSettings.takeFromTemplate.label',
          'Create competitions´ entry rule conditions from global template (if set)'
        ),"value":false}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }